import { AuthMethod } from "@/components/auth/auth_methods";

export function waitForSignInMount(container) {
  return new Promise((resolve, reject) => {
    if (!container) return reject(new Error("container is required"));

    if (container.querySelector(".cl-cardBox")) {
      return resolve(container);
    }

    const obs = new MutationObserver(() => {
      if (container.querySelector(".cl-cardBox")) {
        obs.disconnect();
        resolve(container);
      }
    });

    obs.observe(container, { childList: true, subtree: true });
  });
}

export function updateFormTitle(container, title) {
  const titleElement = container.querySelector(".cl-headerTitle");
  titleElement && (titleElement.textContent = title);
}

export function updateGoogleButtonLabel(container, label) {
  const googleButton = container.querySelector(
    ".cl-socialButtonsBlockButtonText__google"
  );
  googleButton && (googleButton.textContent = label);
}

export function hideDisabledAuthMethods(container, enabledAuthMethods) {
  if (!enabledAuthMethods.includes(AuthMethod.Google)) {
    removeElement(container, ".cl-button__google");
  }
  if (!enabledAuthMethods.includes(AuthMethod.Canvas)) {
    removeElement(container, ".cl-button__custom_canvas");
  }
  if (!enabledAuthMethods.includes(AuthMethod.Native)) {
    removeElement(container, ".cl-form");
    removeElement(container, ".cl-dividerRow");
  }
}

export function hideCanvasAuthMethods(container) {
  removeElement(container, ".cl-button__custom_canvas");
}

function removeElement(container, selector) {
  const element = container.querySelector(selector);
  element && element.remove();
}
